<script setup lang="ts">
import { GlassButton } from '~/components/GlassButton';

interface PropertyHeroActionButtonProps {
	shape?: 'square' | 'circle';
}

withDefaults(defineProps<PropertyHeroActionButtonProps>(), {
	shape: 'square'
});
</script>

<template>
	<GlassButton
		:shape="shape"
		class="h-11 shrink-0 gap-2 px-4 text-sm font-normal text-white"
	>
		<slot />
	</GlassButton>
</template>
